import { useRef, useState, useEffect } from "react";
import "./ResetPassword.css";
import { ReactComponent as Arrow } from "../assets/arrow.svg";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../assets/Logo.svg";
import { auth } from "../firebase/firebaseConfig";
import { confirmPasswordReset } from "firebase/auth";
import { useIsMobile } from "../hooks/useIsMobile";
import Background from "./Background";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");

  const passwordRef = useRef(null);
  const passwordRepeatRef = useRef(null);

  const [x, setX] = useState(0);

  const [currentRef, setCurrentRef] = useState(null);
  const [resetting, setResetting] = useState(false);

  const [passwordTooShort, setPasswordTooShort] = useState(true);
  const [passwordUpperCaseMissing, setPasswordUpperCaseMissing] =
    useState(true);
  const [passwordLowerCaseMissing, setPasswordLowerCaseMissing] =
    useState(true);
  const [passwordNumbersMissing, setPasswordNumbersMissing] = useState(true);
  const [passwordsMatch, setPasswordsMatch] = useState(false);

  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const urlParams = new URLSearchParams(window.location.search);
  const oobCode = urlParams.get("oobCode");

  useEffect(() => {
    if (currentRef)
      setTimeout(() => {
        currentRef.current.focus();
      }, 500);
  }, [x]);

  const checkPassword = (password) => {
    if (password.length >= 8) setPasswordTooShort(false);
    else setPasswordTooShort(true);

    if (/[A-Z]/.test(password)) setPasswordUpperCaseMissing(false);
    else setPasswordUpperCaseMissing(true);

    if (/[a-z]/.test(password)) setPasswordLowerCaseMissing(false);
    else setPasswordLowerCaseMissing(true);

    if (/\d/.test(password)) setPasswordNumbersMissing(false);
    else setPasswordNumbersMissing(true);
  };

  const submitPassword = () => {
    if (
      !passwordTooShort &&
      !passwordUpperCaseMissing &&
      !passwordLowerCaseMissing &&
      !passwordNumbersMissing
    ) {
      setCurrentRef(passwordRepeatRef);
      setX(x + 1);
    }
  };

  const resetPassword = async () => {
    setResetting(true);
    await confirmPasswordReset(auth, oobCode, password).catch((e) => {});
    navigate("/", { replace: true });
  };

  return (
    <>
      <Background />
      <div className="reset-password">
        <p className="title">Reset your password</p>
        <div
          className="password"
          style={{ transform: `translateX(-${100 * x}%)` }}
        >
          <p>New Password</p>
          <div
            style={{
              height: isMobile ? "40px" : "50px",
              width: isMobile ? "90%" : "35%",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <input
              value={password}
              onChange={(e) => {
                setPassword(e.currentTarget.value);
                checkPassword(e.currentTarget.value);
              }}
              type="password"
              inputMode="text"
              ref={passwordRef}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  submitPassword();
                }
              }}
            ></input>
            <div
              className="next-button"
              onClick={() => {
                submitPassword();
              }}
            >
              <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
            </div>
          </div>
          <div
            className="error"
            style={{ display: !passwordTooShort && "none" }}
          >
            • Minimum of 8 Characters
          </div>
          <div
            className="error"
            style={{ display: !passwordUpperCaseMissing && "none" }}
          >
            • atleast one uppercase letter [A-Z]
          </div>
          <div
            className="error"
            style={{ display: !passwordLowerCaseMissing && "none" }}
          >
            • atleast one lowercase letter [a-z]
          </div>
          <div
            className="error"
            style={{ display: !passwordNumbersMissing && "none" }}
          >
            • atleast one Number [0-9]
          </div>
        </div>
        <div
          className="password-repeat"
          style={{ transform: `translateX(-${100 * x}%)` }}
        >
          <p>Repeat New Password</p>
          <div
            style={{
              height: isMobile ? "40px" : "50px",
              width: isMobile ? "90%" : "35%",
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <div
              className="previous-button"
              onClick={() => {
                setCurrentRef(passwordRef);
                setX(x - 1);
              }}
            >
              <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
            </div>
            <Logo
              className="email-checking"
              style={{
                width: "10%",
                height: "100%",
                filter: "drop-shadow(0px 0px 10px white)",
                display: !resetting && "none",
              }}
            ></Logo>
            <input
              value={passwordRepeat}
              onChange={(e) => {
                setPasswordRepeat(e.currentTarget.value);
                if (e.currentTarget.value === password) setPasswordsMatch(true);
                else setPasswordsMatch(false);
              }}
              type="password"
              inputMode="text"
              ref={passwordRepeatRef}
              onKeyDown={(e) => {
                if (e.key === "Enter" && passwordsMatch && !resetting) {
                  resetPassword();
                } else if (
                  e.key === "Backspace" &&
                  passwordRepeat.length === 0
                ) {
                  setCurrentRef(passwordRef);
                  setX(x - 1);
                }
              }}
            ></input>
            <div
              className="next-button"
              onClick={() => {
                if (passwordsMatch && !resetting) resetPassword();
              }}
            >
              <Arrow style={{ height: "100%", width: "80%" }}></Arrow>
            </div>
          </div>
          <div className="error" style={{ display: passwordsMatch && "none" }}>
            • Passwords don't match!
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
